import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusCode } from '../../components/Alert.tsx';
import StoresController from '../../controllers/StoresController.ts';
import { Store } from '../../models/stores/store.ts';
import { useAlert } from '../alertProvider.tsx';

type StoreContextType = {
    isLoaded?: boolean;
    store: Store;
    insertStore: (entity: Store) => void;
    updateStore: (entity: Store) => void;
};

const StoreContext = createContext<StoreContextType>({} as StoreContextType);

export const StoreContextProvider = ({ children, id }: { children: any, id?: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [store, setStore] = useState<Store>({} as Store);
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    useEffect(() => {
        const getStoreByID = async () => {
            if (id == "create") { setIsLoaded(true); return; }
            try {
                const result = await StoresController.getByID(id);
                if (result.notificationStatus == StatusCode.success)
                    setStore(result);
                else showAlert(result.notificationStatus, result.notificationMessage);
            } catch (error) {
                console.error('Error fetching store:', error);
            } finally {
                setIsLoaded(true);
            }
        }
        getStoreByID();
    }, [id]);

    const insertStore = async (entity: Store) => {
        try {
            const result = await StoresController.post(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error inserting store:', error);
        }
    }

    const updateStore = async (entity: Store) => {
        try {
            const result = await StoresController.put(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error updating store:', error);
        }
    }

    const context: StoreContextType = {
        isLoaded,
        store,
        insertStore,
        updateStore
    }

    return (
        <StoreContext.Provider value={context}>
            {children}
        </StoreContext.Provider>
    )
}

export const useStoreContext = () => useContext(StoreContext)
